(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4813],{

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(4836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));
var _jsxRuntime = __webpack_require__(5893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');

/***/ }),

/***/ 4804:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-storage-policy",
      function () {
        return __webpack_require__(9949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5653:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/mainbg.98d4766a.webp","height":935,"width":1391,"blurDataURL":"data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAACQAQCdASoIAAUAAkA4JaQAAp0LKOAA/v4yW37BK1m9hcc/8Lcd5AF84QAAAA==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 4208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppWrapperContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6886);
/* harmony import */ var _AppNavBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7486);



function AppWrapperContainer(param) {
    let { children , nav , navBgColor  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        sx: {
            paddingTop: {
                xs: "55px",
                md: "72px"
            }
        },
        children: [
            nav ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppNavBar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                navBgColor: navBgColor
            }) : null,
            children
        ]
    });
}


/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function toRobotsContent(robots) {
    if (!robots) return undefined;
    var _index;
    const index = (_index = robots.index) !== null && _index !== void 0 ? _index : true;
    var _follow;
    const follow = (_follow = robots.follow) !== null && _follow !== void 0 ? _follow : true;
    return "".concat(index ? "index" : "noindex", ", ").concat(follow ? "follow" : "nofollow");
}
function Seo(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const description = (ref = props.description) === null || ref === void 0 ? void 0 : ref.trim();
    const canonicalUrl = (ref1 = props.canonicalUrl) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var ref13;
    const ogTitle = (ref13 = (ref2 = props.openGraph) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref13 !== void 0 ? ref13 : props.title;
    var ref14;
    const ogDescription = (ref14 = (ref3 = props.openGraph) === null || ref3 === void 0 ? void 0 : ref3.description) !== null && ref14 !== void 0 ? ref14 : description;
    var ref15;
    const ogType = (ref15 = (ref4 = props.openGraph) === null || ref4 === void 0 ? void 0 : ref4.type) !== null && ref15 !== void 0 ? ref15 : "website";
    var ref16;
    const ogUrl = (ref16 = (ref5 = props.openGraph) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref16 !== void 0 ? ref16 : canonicalUrl;
    var ref17;
    const twCard = (ref17 = (ref6 = props.twitter) === null || ref6 === void 0 ? void 0 : ref6.card) !== null && ref17 !== void 0 ? ref17 : "summary_large_image";
    var ref18;
    const twTitle = (ref18 = (ref7 = props.twitter) === null || ref7 === void 0 ? void 0 : ref7.title) !== null && ref18 !== void 0 ? ref18 : props.title;
    var ref19;
    const twDescription = (ref19 = (ref8 = props.twitter) === null || ref8 === void 0 ? void 0 : ref8.description) !== null && ref19 !== void 0 ? ref19 : description;
    var ref20;
    const twUrl = (ref20 = (ref9 = props.twitter) === null || ref9 === void 0 ? void 0 : ref9.url) !== null && ref20 !== void 0 ? ref20 : canonicalUrl;
    const robotsContent = toRobotsContent(props.robots);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }, "title"),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description") : null,
            props.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }, "keywords") : null,
            canonicalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robotsContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: robotsContent
            }, "robots") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: ogTitle
            }, "og:title"),
            ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: ogDescription
            }, "og:description") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }, "og:type"),
            ((ref10 = props.openGraph) === null || ref10 === void 0 ? void 0 : ref10.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: props.openGraph.image
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: props.openGraph.image
                    }, "og:image:secure_url")
                ]
            }) : null,
            ogUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }, "og:url") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: twCard
            }, "twitter:card"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twTitle
            }, "twitter:title"),
            twDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twDescription
            }, "twitter:description") : null,
            ((ref11 = props.twitter) === null || ref11 === void 0 ? void 0 : ref11.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.twitter.image
            }, "twitter:image") : null,
            twUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: twUrl
            }, "twitter:url") : null,
            (ref12 = props.jsonLd) === null || ref12 === void 0 ? void 0 : ref12.map((block, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(block)
                    }
                }, "jsonld-".concat(idx))),
            props.children
        ]
    });
}


/***/ }),

/***/ 9949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5861);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_AppFooter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9705);
/* harmony import */ var _components_AppWrapperContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4208);
/* harmony import */ var _data_StaticList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4485);
/* harmony import */ var _public_assets_images_mainbg_webp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5653);
/* harmony import */ var _components_Seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2448);








const ListItems = (param)=>{
    let { desc  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        children: desc.map((d, i)=>{
            var ref;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        style: {
                            fontSize: 17,
                            paddingTop: d.text == "Redemption GroMo Coins" || d.text == "GroMo Coins have an expiry of 3 months and the gromo coins will be expired on month end i.e. if a GroMo Partner earned 2000 GroMo Coins on 12th May, then those 2000 GroMo Coins will expire by 31st August." ? "16px" : "0"
                        },
                        children: d.text
                    }, i),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    d.points ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                        type: d.pointsType,
                        children: (ref = d.points) === null || ref === void 0 ? void 0 : ref.map((p, j)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    style: {
                                        fontSize: 15,
                                        marginBottom: 2
                                    },
                                    children: p
                                })
                            }, "".concat(i, "_").concat(j));
                        })
                    }) : null
                ]
            }, "".concat(i, "_listItem"));
        })
    }, "GridContainer");
};
function TermCondition() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Seo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "Data Storage Policy | GroMo",
                description: "Download the GroMo app and become a partner to earn regular income by selling financial products. Start your online business with GroMo money making application",
                keywords: "GroMo Money Making Application",
                openGraph: {
                    title: "Data Storage Policy | GroMo",
                    description: "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
                    type: "website",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                },
                twitter: {
                    title: "Data Storage Policy | GroMo",
                    description: "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
                    url: "https://gromo.in/data-storage-policy",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppWrapperContainer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                nav: true,
                navBgColor: "white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    paddingTop: 4,
                    style: {
                        background: 'url("'.concat(_public_assets_images_mainbg_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src, '")'),
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundAttachment: "fixed"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    fontWeight: 600,
                                    style: {
                                        fontSize: "14px",
                                        width: "fit-content",
                                        borderBottom: "3px solid",
                                        marginBottom: 16
                                    },
                                    children: "Data Storage Policy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                style: {
                                    // maxWidth: 900,
                                    paddingBottom: "16px"
                                },
                                children: _data_StaticList__WEBPACK_IMPORTED_MODULE_4__/* .DATA_STORAGE_POLICY.map */ .$n.map((term, i)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                        style: {
                                            padding: "12px 16px",
                                            borderRadius: 8,
                                            transition: "0.3s ease-in-out",
                                            margin: "16px 0"
                                        },
                                        sx: {
                                            background: "#fffffff2",
                                            boxShadow: "0px 0px 2px 0px grey",
                                            ":hover": {
                                                background: "#ffffff",
                                                boxShadow: "0px 0px 3px 0px grey"
                                            }
                                        },
                                        id: term.title === "REFERRAL POLICY" ? "rp" : "",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                                paddingBottom: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    sx: {
                                                        fontSize: "12px"
                                                    },
                                                    children: term.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                                children: term.textType ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                                                    type: term.textType,
                                                    style: {
                                                        margin: 0
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItems, {
                                                        desc: term.desc
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    style: {
                                                        listStyle: "none",
                                                        margin: 0
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItems, {
                                                        desc: term.desc
                                                    })
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppFooter__WEBPACK_IMPORTED_MODULE_2__["default"], {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (TermCondition);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3581,6886,6499,5675,7538,5045,4485,9705,7486,9774,2888,179], function() { return __webpack_exec__(4804); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);